import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Spin, Tabs, List, Input } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPermissionMappings } from './actions';
import { getPermissionMappings, getPermissionMappingsLoading } from './selectors';

const { Search } = Input;

type Props = {
  visible: boolean;
  permissionId: number | null;
  displayName?: string;
  onClose: () => void;
};

export default function PermissionMappingsModal({ visible, permissionId, displayName, onClose }: Props) {
  const dispatch = useDispatch();
  const loading = useSelector(getPermissionMappingsLoading);
  const mappings = useSelector((state: any) =>
    permissionId ? getPermissionMappings(state, permissionId) : { Roles: [], Users: [] }
  );

  const [rolesSearch, setRolesSearch] = useState('');
  const [usersSearch, setUsersSearch] = useState('');

  useEffect(() => {
    if (visible && permissionId != null) {
      dispatch(fetchPermissionMappings(permissionId));
    }
  }, [visible, permissionId, dispatch]);

  const filteredRoles = useMemo(
    () =>
      (mappings?.Roles || []).filter((r: any) =>
        `${r.DisplayName || r.Name}`.toLowerCase().includes((rolesSearch || '').toLowerCase())
      ),
    [mappings, rolesSearch]
  );
  const filteredUsers = useMemo(
    () =>
      (mappings?.Users || []).filter((u: any) =>
        `${u.Name || ''} ${u.Email || ''}`.toLowerCase().includes((usersSearch || '').toLowerCase())
      ),
    [mappings, usersSearch]
  );

  return (
    <Modal title={'Mapped User Roles and Users'} visible={visible} onCancel={onClose} footer={null} width={720}>
      <Spin spinning={loading}>
        <Tabs defaultActiveKey='roles'>
          <Tabs.TabPane tab='Roles' key='roles'>
            <div style={{ marginBottom: 8 }}>
              <Search placeholder='Search roles' onChange={(e) => setRolesSearch(e.target.value)} value={rolesSearch} />
            </div>
            <List
              size='small'
              bordered
              dataSource={filteredRoles}
              renderItem={(r: any) => (
                <List.Item key={r.Id}>
                  <div>
                    <div style={{ fontWeight: 500 }}>{r.DisplayName || r.Name}</div>
                    {r.Name ? <div style={{ fontSize: 12, color: '#666' }}>{r.Name}</div> : null}
                  </div>
                </List.Item>
              )}
              locale={{ emptyText: 'No roles' }}
              style={{ maxHeight: 420, overflow: 'auto' }}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab='Users' key='users'>
            <div style={{ marginBottom: 8 }}>
              <Search placeholder='Search users' onChange={(e) => setUsersSearch(e.target.value)} value={usersSearch} />
            </div>
            <List
              size='small'
              bordered
              dataSource={filteredUsers}
              renderItem={(u: any) => (
                <List.Item key={u.Id || u.Email}>
                  <div>
                    <div style={{ fontWeight: 500 }}>{u.Name}</div>
                    <div style={{ fontSize: 12, color: '#666' }}>{u.Email}</div>
                  </div>
                </List.Item>
              )}
              locale={{ emptyText: 'No users' }}
              style={{ maxHeight: 420, overflow: 'auto' }}
            />
          </Tabs.TabPane>
        </Tabs>
      </Spin>
    </Modal>
  );
}
